import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const EditPlanModal = ({ isOpen, plan, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    monthlyPrice: '',
    yearlyPrice: '',
    featuresCount: ''
  });

  useEffect(() => {
    if (plan) {
      setFormData({
        name: plan?.name || '',
        monthlyPrice: plan?.monthlyPrice || '',
        yearlyPrice: plan?.yearlyPrice || '',
        featuresCount: plan?.featuresCount || ''
      });
    }
  }, [plan]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave({
      ...plan,
      ...formData,
      monthlyPrice: Number(formData?.monthlyPrice),
      yearlyPrice: Number(formData?.yearlyPrice),
      featuresCount: Number(formData?.featuresCount)
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-lg shadow-xl max-w-lg w-full p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-semibold text-foreground flex items-center gap-2">
            <Icon name="Edit" size={24} className="text-primary" />
            Edit Plan
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-md transition-smooth"
          >
            <Icon name="X" size={20} className="text-muted-foreground" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Plan Name"
            type="text"
            value={formData?.name}
            onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
            required
          />
          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Monthly Price (₹)"
              type="number"
              value={formData?.monthlyPrice}
              onChange={(e) => setFormData({ ...formData, monthlyPrice: e?.target?.value })}
              required
            />
            <Input
              label="Yearly Price (₹)"
              type="number"
              value={formData?.yearlyPrice}
              onChange={(e) => setFormData({ ...formData, yearlyPrice: e?.target?.value })}
              required
            />
          </div>
          <Input
            label="Features Count"
            type="number"
            value={formData?.featuresCount}
            onChange={(e) => setFormData({ ...formData, featuresCount: e?.target?.value })}
            required
          />
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Save"
              iconPosition="left"
              fullWidth
            >
              Save Changes
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPlanModal;